import { PaymentMethod } from "#graphql/supergraphEnums";
import { PaymentCapabilities } from "./types";

export const stringToPaymentMethod = (
  paymentMethodString?: string | null,
): PaymentMethod | null => {
  if (!paymentMethodString) {
    return null;
  }
  const maybeMethod = paymentMethodString.toUpperCase() as PaymentMethod;
  if (Object.values(PaymentMethod).includes(maybeMethod)) {
    return maybeMethod;
  }
  return null;
};

export const isPaymentMethodSupported = (
  paymentMethod: PaymentMethod,
  capabilities: PaymentCapabilities,
): boolean => {
  switch (paymentMethod) {
    case PaymentMethod.Wire:
      return capabilities.wirePayments;
    case PaymentMethod.Ach:
      return capabilities.achPayments;
    default:
      return false;
  }
};
